/* eslint-disable indent */
const moment = require('moment-timezone');
const { testCredentials } = require('./constants');
const { MLB } = require('./Images/Countries');

const getFrontSnippetPlaceholder = (formData, finalPaymentMethods, i18n) => `
  <html>
  <head>
    <script src="https://sdk.mercadopago.com/js/v2"></script>
  </head>
  <body>
    <div id="walletBrick_container"></div>
    <script>
      const mp = new MercadoPago('YOUR_PUBLIC_KEY', {
        locale: '${formData.language}'
      });
      const bricksBuilder = mp.bricks();
      const renderWalletBrick = async (bricksBuilder) => {
        const settings = {
          initialization: {
            amount: 10000, // ${i18n.gettext('monto a ser pago')}
          },
          customization: {
            ${
              formData.maxInstallments > 1
                ? `maxInstallments: ${formData.maxInstallments},`
                : ''
            }
            visual: {
              ${!formData.showTitle ? 'hideFormTitle: true,' : ''}
              ${!formData.showPaymentButton ? 'hidePaymentButton: true,' : ''}
              style: {
                theme: ${
                  `'${formData.theme}'` || 'default'
                }, // | 'dark' | 'bootstrap' | 'flat'
              }
            },
            ${
              formData.paymentMethod.length < 2
                ? `
              paymentMethods: {
                types: {
                  excluded: [${finalPaymentMethods.map((item) => `'${item}'`)}]
                }
              }
            `
                : ''
            }
          },
          callbacks: {
            onReady: () => {
              // ${i18n.gettext('callback llamado cuando Brick esté listo')}
            },
            onSubmit: (cardFormData) => {
              //  ${i18n.gettext('callback llamado cuando el usuario haga clic en el botón enviar los datos')}
              //  ${i18n.gettext('ejemplo de envío de los datos recolectados por el Brick a su servidor')}
              return new Promise((resolve, reject) => {
                fetch("/process_payment", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(cardFormData)
                })
                  .then((response) => {
                    // ${i18n.gettext('recibir el resultado del pago')}
                    resolve();
                  })
                  .catch((error) => {
                    // ${i18n.gettext('tratar respuesta de error al intentar crear el pago')}
                    reject();
                  })
              });
            },
            onError: (error) => {
              // ${i18n.gettext('callback llamado para todos los casos de error de Brick')}
            },
          },
        };
        window.walletBrickController = await bricksBuilder.create('wallet', 'walletBrick_container', settings);
      };
      renderWalletBrick(bricksBuilder);
    </script>
  </body>
  </html>
  `;

const getYellowBrandPublicKeyList = (brand) => {
  const isMiddlewareYellowBrand = brand ? brand !== 'cyan-light' : false;

  const rolloutDates = {
    mlc: moment('2025-02-25'),
    mlm: moment('2025-03-17'),
    mco: moment('2025-03-17'),
    mpe: moment('2025-03-17'),
    mlu: moment('2025-03-17'),
    mlb: moment('2025-04-15'),
    mla: moment.tz('2025-05-19 20:30', 'YYYY-MM-DD HH:mm', 'America/Argentina/Buenos_Aires'),
  };

  const currentDate = moment();

  function isAfterRolloutDate(siteId, currentD) {
    const defaultDate = rolloutDates.mla;
    const rolloutDate = rolloutDates[siteId] || defaultDate;

    if (siteId === 'mla') {
      const currentInMLA = currentD.clone().tz('America/Argentina/Buenos_Aires');
      return currentInMLA.isAfter(rolloutDate);
    }

    return currentD.isAfter(rolloutDate, 'day');
  }

  return testCredentials
    .filter(item => {
      const siteId = item.siteId.toLowerCase();
      if (isMiddlewareYellowBrand && currentDate.isBefore(rolloutDates.mlc)) {
        return true;
      }
      return isAfterRolloutDate(siteId, currentDate);
    })
    .map(item => item.publicKey);
};

const getBlueBrandPublicKeyList = (brand) => {
  const yellowSites = getYellowBrandPublicKeyList(brand);
  return testCredentials
    .filter(item => !yellowSites.includes(item.publicKey))
    .map(item => item.publicKey);
};

const isPublicKeyYellowBrand = (publicKey, brand) => {
  const yellowSites = getYellowBrandPublicKeyList(brand);
  return yellowSites.includes(publicKey);
};

const finalPublicKey = (publicKey, brand) => {
  const credential = testCredentials.find(cred => cred.publicKey === publicKey || cred.yellowPublicKey === publicKey);
  if (!credential) throw new Error('Public key not found');
  return isPublicKeyYellowBrand(publicKey, brand) ? credential.yellowPublicKey : credential.publicKey;
};

module.exports = {
  getFrontSnippetPlaceholder,
  getYellowBrandPublicKeyList,
  getBlueBrandPublicKeyList,
  isPublicKeyYellowBrand,
  finalPublicKey,
};
